import React from "react";
import { RadixFlyOut } from "../primitives/RadixFlyOut";
import { RadixButton } from "../primitives/RadixButton";
import "./orderReviewFlyOut.css";
import { formatCurrency } from "../utility/formatCurrency";
import { formatter } from "../utility/formatter";
var formatOrderDate = function (value) {
    if (!value) {
        return "Unknown date";
    }
    var parsedDate = new Date(value);
    if (Number.isNaN(parsedDate.getTime())) {
        return "Unknown date";
    }
    return parsedDate.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
};
var toNumber = function (value) {
    if (value === null || value === undefined || value === "") {
        return 0;
    }
    var numericValue = typeof value === "string" ? Number(value) : value;
    return Number.isNaN(numericValue) ? 0 : numericValue;
};
var toProperTitle = function (value) {
    return value
        .split(" ")
        .filter(function (part) { return part.length > 0; })
        .map(function (part) { return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase(); })
        .join(" ");
};
export var OrderReviewFlyOut = function (_a) {
    var _b, _c, _d, _e;
    var open = _a.open, onOpenChange = _a.onOpenChange, order = _a.order, onRepeatOrder = _a.onRepeatOrder, isRepeating = _a.isRepeating;
    var orderLines = Array.isArray(order === null || order === void 0 ? void 0 : order.lines) ? order.lines : [];
    var computedOrderTotal = toNumber(order === null || order === void 0 ? void 0 : order.subtotal)
        + toNumber(order === null || order === void 0 ? void 0 : order.tax)
        + toNumber(order === null || order === void 0 ? void 0 : order.delivery_fee)
        + toNumber(order === null || order === void 0 ? void 0 : order.delivery_tip)
        + toNumber(order === null || order === void 0 ? void 0 : order.nca_fee)
        + toNumber(order === null || order === void 0 ? void 0 : order.service_fee);
    var hasTechnologyFee = toNumber(order === null || order === void 0 ? void 0 : order.nca_fee) > 0;
    var hasServiceFee = toNumber(order === null || order === void 0 ? void 0 : order.service_fee) > 0;
    var hasDeliveryFee = toNumber(order === null || order === void 0 ? void 0 : order.delivery_fee) > 0;
    var ncaFeeTitle = ((_c = (_b = window.session) === null || _b === void 0 ? void 0 : _b.store) === null || _c === void 0 ? void 0 : _c.nca_title) && window.session.store.nca_title.trim().length > 0
        ? toProperTitle(window.session.store.nca_title)
        : "Technology fee";
    var serviceFeeTitle = ((_e = (_d = window.session) === null || _d === void 0 ? void 0 : _d.store) === null || _e === void 0 ? void 0 : _e.service_fee_title) && window.session.store.service_fee_title.trim().length > 0
        ? toProperTitle(window.session.store.service_fee_title)
        : "Service Fee";
    return (React.createElement(RadixFlyOut, { open: open, onOpenChange: onOpenChange, title: (order === null || order === void 0 ? void 0 : order.reference) ? "Order #".concat(order.reference) : "Order details", description: "Review all items and charges from this order." },
        React.createElement("div", { className: "order-review-flyout order-review-flyout-shell" },
            React.createElement("div", { className: "order-review-flyout__scroll" },
                React.createElement("section", { className: "order-review-flyout__section order-review-flyout__meta" },
                    React.createElement("p", null,
                        React.createElement("span", { className: "order-review-flyout__label" }, "Date"),
                        formatOrderDate(order === null || order === void 0 ? void 0 : order.created_at)),
                    React.createElement("p", null,
                        React.createElement("span", { className: "order-review-flyout__label" }, "Payment"),
                        formatter.toProperCase(order === null || order === void 0 ? void 0 : order.payment_type) || "N/A")),
                React.createElement("section", { className: "order-review-flyout__section" },
                    React.createElement("h4", { className: "order-review-flyout__section-title" }, "Items"),
                    orderLines.length > 0 ? (React.createElement("ul", { className: "order-review-flyout__line-list" }, orderLines.map(function (line, index) {
                        var _a, _b, _c;
                        return (React.createElement("li", { key: String((_a = line.id) !== null && _a !== void 0 ? _a : "".concat(line.item_id, "-").concat(index)), className: "order-review-flyout__line-item" },
                            React.createElement("p", { className: "order-review-flyout__line-title" }, (_b = line.quantity) !== null && _b !== void 0 ? _b : 1,
                                "\u00D7 ", (_c = line.name) !== null && _c !== void 0 ? _c : "Item"),
                            Array.isArray(line.modifications) && line.modifications.length > 0 ? (React.createElement("ul", { className: "order-review-flyout__mod-list" }, line.modifications.map(function (modification, modificationIndex) {
                                var _a, _b;
                                return (React.createElement("li", { key: String((_a = modification.id) !== null && _a !== void 0 ? _a : "".concat(modification.modification_id, "-").concat(modificationIndex)) },
                                    modification.quantity && modification.quantity > 1 ? "".concat(modification.quantity, "\u00D7 ") : "", (_b = formatter.removeTrailingAsterisk(modification.name)) !== null && _b !== void 0 ? _b : "Modifier",
                                    modification.portion ? " (".concat(modification.portion, ")") : "",
                                    modification.size ? " - ".concat(modification.size) : ""));
                            }))) : null,
                            line.comment ? React.createElement("p", { className: "order-review-flyout__comment" },
                                "Note: ",
                                line.comment) : null));
                    }))) : (React.createElement("p", { className: "order-review-flyout__empty" }, "No items found for this order."))),
                React.createElement("section", { className: "order-review-flyout__section order-review-flyout__totals" },
                    React.createElement("p", null,
                        React.createElement("span", null, "Subtotal"),
                        formatCurrency(order === null || order === void 0 ? void 0 : order.subtotal)),
                    React.createElement("p", null,
                        React.createElement("span", null, "Tax"),
                        formatCurrency(order === null || order === void 0 ? void 0 : order.tax)),
                    hasDeliveryFee ? (React.createElement("p", null,
                        React.createElement("span", null, "Delivery fee"),
                        formatCurrency(order === null || order === void 0 ? void 0 : order.delivery_fee))) : null,
                    React.createElement("p", null,
                        React.createElement("span", null, "Tip"),
                        formatCurrency(order === null || order === void 0 ? void 0 : order.delivery_tip)),
                    hasTechnologyFee ? (React.createElement("p", null,
                        React.createElement("span", null, ncaFeeTitle),
                        formatCurrency(order === null || order === void 0 ? void 0 : order.nca_fee))) : null,
                    hasServiceFee ? (React.createElement("p", null,
                        React.createElement("span", null, serviceFeeTitle),
                        formatCurrency(order === null || order === void 0 ? void 0 : order.service_fee))) : null,
                    React.createElement("p", { className: "order-review-flyout__total-row" },
                        React.createElement("span", null, "Total"),
                        React.createElement("strong", null, formatCurrency(computedOrderTotal))))),
            React.createElement("div", { className: "order-review-flyout__actions" },
                React.createElement(RadixButton, { className: "order-review-flyout__repeat-button", onClick: function () {
                        if (order) {
                            onRepeatOrder(order);
                        }
                    }, disabled: !order || isRepeating }, isRepeating ? "Repeating..." : "Repeat order")))));
};
